import { useLocalStorage } from '@vueuse/core';

export type CompareProduct = {
  partNo: string;
  name: string;
  imageUrl: string;
  url: string;
};

const STORAGE_KEY = 'compare-list';

export default function useCompare() {
  const compareList = useLocalStorage<CompareProduct[]>(STORAGE_KEY, []);

  const isInCompare = (partNo: string) =>
    compareList.value.some(p => p.partNo === partNo);

  const addToCompare = (product: CompareProduct) => {
    if (isInCompare(product.partNo)) { return; }
    compareList.value = [...compareList.value, product];
  };

  const removeFromCompare = (partNo: string) => {
    compareList.value = compareList.value.filter(p => p.partNo !== partNo);
  };

  const toggleCompare = (product: CompareProduct) => {
    if (isInCompare(product.partNo)) {
      removeFromCompare(product.partNo);
    } else {
      addToCompare(product);
    }
  };

  return {
    compareList,
    isInCompare,
    addToCompare,
    removeFromCompare,
    toggleCompare,
  };
}
